import { Fragment, type PropsWithChildren, type ReactNode } from "react";
import styles from "./styles";

interface ListViewItemCardProps {
  text?: string;
  subText?: ReactNode;
  shrinkable?: boolean;
  subSubText?: string;
  subSubTextColor?: string;
  icon?: React.ReactNode;
  wrap?: boolean;
  marginTop?: number;
  onClick?: () => void;
}

const ListViewItemCard = (props: PropsWithChildren<ListViewItemCardProps>) => {
  return (
    <div
      style={{
        ...(props.text == null ? styles.wrapperAuto : styles.wrapper),
        ...(props.shrinkable ? { minWidth: 0 } : {}),
      }}
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        }
      }}
    >
      <div style={styles.container}>
        {props.icon != null && (
          <div style={{ ...styles.iconFlex, height: "100%", alignContent: "center" }}>{props.icon}</div>
        )}

        {props.text != null && (
          <Fragment>
            <div style={{ ...styles.detailFlex, ...(props.shrinkable ? { minWidth: 0 } : {}) }}>
              <div
                style={{
                  maxHeight: props.wrap != false ? 20 : "none",
                  marginRight: 5,
                  marginTop: props.marginTop,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <b>{props.text}</b>
              </div>
              {props.subText != null && (
                <Fragment>
                  <div
                    style={{
                      maxHeight: props.wrap != false ? 20 : "none",
                      marginRight: 5,
                      marginTop: props.marginTop,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {props.subText}

                  </div>
                </Fragment>
              )}
              {props.subSubText != null && (
                <Fragment>
                  <div
                    style={{
                      maxHeight: props.wrap != false ? 20 : "none",
                      marginRight: 5,
                      marginTop: props.marginTop,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      color: props.subSubTextColor == null ? "black" : props.subSubTextColor
                    }}
                  >
                    {props.subSubText}

                  </div>
                </Fragment>
              )}
            </div>
          </Fragment>
        )}


      </div>
    </div>
  );
};

export default ListViewItemCard;
